module.exports = [{
      plugin: require('E:/u-codes/storybok/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"E:\\u-codes\\storybok\\src\\templates\\markdown-page.js"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-copy-linked-files"},{"resolve":"E:\\u-codes\\storybok\\plugins\\remark-images\\index.js","options":{"showCaptions":true,"backgroundColor":"#fafafa","maxWidth":1035,"watermark":"E:\\u-codes\\storybok/src/images/watermark.png","watermarkGravity":"southwest","watermarkBlend":"over"}},{"resolve":"E:\\u-codes\\storybok\\plugins\\remark-embedder\\index.js"}],"extensions":[".mdx",".md",".markdown"]},
    },{
      plugin: require('E:/u-codes/storybok/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('E:/u-codes/storybok/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('E:/u-codes/storybok/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
